export const mediaBreakpoints = {
    mobile: 768,
    tablet: 1024,
};

export default mediaBreakpoints;
